import * as React from 'react';

function SvgProgressLandlordPreApproval(props) {
  return (
    <svg viewBox="0 0 21 23" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.446 19.465C3.05 19.415.85 19.058.85 18.055c0-4.54 4.103-8.205 9.15-8.205a10.1 10.1 0 012.982.445 6.97 6.97 0 00-1.921.918A8.975 8.975 0 0010 11.15c-4.2 0-7.635 2.907-7.84 6.56.06.015.127.031.202.047.42.087 1.047.164 1.846.228 1.069.085 2.416.144 3.887.17.075.453.194.891.351 1.31zM10 11.2A5.2 5.2 0 1110 .8a5.2 5.2 0 010 10.4zm0-1.4a3.8 3.8 0 100-7.6 3.8 3.8 0 000 7.6zm5.286 1.771a5.714 5.714 0 100 11.429 5.714 5.714 0 000-11.429zm0 9.998a4.284 4.284 0 110-8.568 4.284 4.284 0 010 8.568zm1.916-6.195a.65.65 0 11.92.92l-2.829 2.827a.65.65 0 01-.92 0l-1.413-1.414a.65.65 0 11.919-.919l.954.955 2.37-2.37z" />
    </svg>
  );
}

export default SvgProgressLandlordPreApproval;
